// @flow

import { saveAccountsNotesMutation } from '../graphql/mutations/accounts';

const getNotesMutation = (moduleName: string) => {
  switch (moduleName) {
    case 'accounts':
      return saveAccountsNotesMutation;

    default:
      break;
  }

  return '';
};

export { getNotesMutation };
